/* eslint-disable react-hooks/rules-of-hooks */
import { useMapsLibrary } from "@vis.gl/react-google-maps";
import { round } from "lodash";
import { Trans } from "@lingui/macro";
import React, { useContext, useMemo } from "react";
import { Icon } from "../../../components/Icon";
import sendEvent from "../../../functions/analytics";
import { MAX_TOUR_DISTANCE, MIN_TOUR_DISTANCE } from "../constants";
import { OnDemandContext } from "../context";
import { ModeButton } from "./ModeButton";
import { PlacesSearch } from "./PlacesSearch";

export function TourAreaControls() {
  const geometryApi = useMapsLibrary("geometry");
  const { mode, areaRadius, startingPoint, endingPoint, changeMode, changeAreaRadius } =
    useContext(OnDemandContext);
  const radiusKm = areaRadius / 1000;

  const pathDistanceKm = useMemo(() => {
    if (!geometryApi || !startingPoint || !endingPoint) return undefined;

    const distanceMeters = geometryApi.spherical.computeDistanceBetween(startingPoint, endingPoint);

    return round(distanceMeters / 1000, 1);
  }, [startingPoint, endingPoint, geometryApi]);

  const handleRadiusCahnge = e => {
    const { value } = e.currentTarget;
    changeAreaRadius(value * 1000);
  };

  const getPathModeText = () => {
    if (!startingPoint) return <Trans>Select the starting point</Trans>;
    return <Trans>Choose the endpoint or edit the starting point.</Trans>;
  };

  return (
    <div className="tour-area-controls">
      <PlacesSearch />

      {
        {
          radius: (
            <React.Fragment>
              <div className="tour-area-controls__text">
                <div className="tour-area-controls__text__title">
                  <Trans>Select tour zone</Trans>
                </div>
                <div className="tour-area-controls__text__length">
                  <Trans>{radiusKm} km </Trans>
                </div>
              </div>

              <input
                className="tour-area-controls__range-slider"
                type="range"
                min={MIN_TOUR_DISTANCE / 1000}
                max={MAX_TOUR_DISTANCE / 1000}
                step={0.1}
                value={radiusKm}
                onChange={handleRadiusCahnge}
              />
            </React.Fragment>
          ),
          path: (
            <div className="tour-area-controls__text">
              <div>
                <div className="tour-area-controls__text__title">{getPathModeText()}</div>
                <div className="tour-area-controls__text__subtitle">
                  <Trans>Route from 1 to 5 km</Trans>
                </div>
              </div>
              {pathDistanceKm && (
                <div className="tour-area-controls__text__length">
                  <Trans>{pathDistanceKm} km </Trans>
                </div>
              )}
            </div>
          ),
        }[mode]
      }

      <div className="tour-area-controls__buttons">
        <ModeButton
          active={mode === "radius"}
          onClick={() => {
            sendEvent("track", "area_button_click");
            changeMode("radius");
          }}
        >
          <Icon name="area" />
          <Trans>In the area</Trans>
        </ModeButton>

        <ModeButton
          active={mode === "path"}
          onClick={() => {
            sendEvent("track", "route_button_click");
            changeMode("path");
          }}
        >
          <Icon name="route" />
          <Trans>From A to B</Trans>
        </ModeButton>
      </div>
    </div>
  );
}
